import React, {useEffect, useState} from 'react';
import '../scss/components/Profile.scss';
import { IDocument } from '../interface/IDocument.ts';
import { useDocumentApi } from '../features/auth/hooks/use-document-api.ts';
import DocumentsWrapper from '../components/Documentcenter/DocumentsWrapper.tsx';
import { ApiResponseType } from '../features/api/types.ts';
import ApiCheck from '../components/Structure/ApiCheck.tsx';

export default function Documentcenter() {
    const [documents, setDocuments] = useState<IDocument|any>([]);
    const [documentsLoading, setDocumentsLoading] = useState(true);
    const [apiErrors, setApiErrors] = useState<string>();
    const { getDocuments } = useDocumentApi();
    useEffect(() => {
        const genericError = 'Die Dokumente konnten nicht geladen werden. Bitte probieren Sie es später erneut.';
        getDocuments().then(data => {
            // eslint-disable-next-line
            const payload: any = data?.payload;
            if (data?.type === ApiResponseType.OK && Array.isArray(payload)) {
                setDocuments(payload);
            } else {
                // e.g. 403 role_not_validated: { error, message }
                const message = payload?.message ?? payload?.errors;
                setApiErrors(typeof message === 'string' && message.length > 0 ? message : genericError);
            }
            setDocumentsLoading(false);
        }).catch(() => {
            setApiErrors(genericError);
            setDocumentsLoading(false);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);
    
    if (documentsLoading) {
        return (<div className="loader"></div>);
    }
    return (
        <div id="downloads">
            <ApiCheck errors={apiErrors as any}>
                <div className='title'>
                    <h1 className="h3">Dokumentencenter</h1>
                </div>
                <DocumentsWrapper documentList={documents} />
            </ApiCheck>
        </div>
    )
}